import React, {useEffect, useState } from 'react';
import { Input, Button, Form, Typography , Checkbox} from 'antd';

export function Register({ onSubmit, disabled, toggleActiveTab }) {
  const [form] = Form.useForm();
  const [isChecked, setIsChecked] = useState(false);
  const createCookieInHour = (cookieName, cookieValue) => {
    let date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    document.cookie = cookieName + " = " + cookieValue + "; expires = " + date.toGMTString();
}

const  getCookie =(name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

useEffect(()=> {
  const first_name = getCookie('first_name')
 console.log(first_name);
 form.setFieldValue('first_name', getCookie('first_name'))
 form.setFieldValue('last_name', getCookie('last_name'))
 form.setFieldValue("email", getCookie('email'))
 form.setFieldValue('password', getCookie('password'))
}, [])

const submitInfo = ({first_name, last_name, email, password, password2}) => {
    onSubmit({first_name, last_name, email, password, password2});
   form.resetFields(['checkbox']);
};

  return (
    <>
    <Typography.Title level={3} style={{ textAlign: 'center' }}>Register</Typography.Title>
      <Typography.Paragraph style={{ textAlign: 'center' }}>
        <span>Have an account?</span>
        <Button type="link" onClick={toggleActiveTab}>log in</Button>
      </Typography.Paragraph>
    <Form
      name="register"
      onFinish={ submitInfo }
      layout="vertical"
      requiredMark={ false }
      initialValues={{
        agreeToTerms: false,
      }}
      form={form}
    >
      <Form.Item
        label="First Name"
        name="first_name"
        hasFeedback
        rules={[{ required: true, message: 'Please enter your first name.' }]}
      >
        <Input autoComplete="given-name" disabled={ disabled }  onChange={(event) => {createCookieInHour('first_name',event.target.value )}} />
      </Form.Item>
      <Form.Item
        label="Last Name"
        name="last_name"
        hasFeedback
        rules={[{ required: true, message: 'Please enter your last name.' }]}
      >
        <Input autoComplete="family-name" disabled={ disabled } onChange={(event) => {createCookieInHour('last_name',event.target.value )}}/>
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        hasFeedback
        rules={[
          { type: 'email', message: 'Not a valid email.' },
          { required: true, message: 'Please enter your email.' },
        ]}
      >
        <Input type="email" autoComplete="email" disabled={ disabled } onChange={(event) => {createCookieInHour('email',event.target.value )}}/>
      </Form.Item>
      <Form.Item
        label="Password"
        name="password"
        hasFeedback
        rules={[
          { required: true, message: 'Please enter a password.' },
          { min: 6, message: 'Must be at least 6 characters long.' },
          {
            pattern: new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,64}$/),
            message: "Must be minimum of three of the following mix of character types: uppercase, lowercase, numbers, and ! @ # $ % ^ & * ( ) _ + - = [ ] { } | ' symbols"
          }
        ]}
      >
        <Input.Password autoComplete="new-password" disabled={ disabled }/>
      </Form.Item>
      <Form.Item
        label="Confirm Password"
        name="password2"
        dependencies={['password']}
        hasFeedback
        rules={[
          { required: true, message: 'Please enter a password.' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The two passwords do not match!'));
            },
          }),
        ]}
      >
        <Input.Password autoComplete="new-password" disabled={ disabled } />
      </Form.Item>
      
      <Form.Item 
      hasFeedback
      name="checkbox"
      valuePropName="checked"
      rules={[
        {
          required: true,
          message: 'Please agree to the terms and conditions.',
        },
      ]}>
          <Checkbox disabled={ disabled } >
          
              By registering, you are agreeing with
              the <a href="https://builty.app/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>.
             
          </Checkbox>
        </Form.Item>
        <Form.Item>
          <div style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" disabled={ disabled } style={{ minWidth: 190 }} size="large">Register</Button>
          </div>
      </Form.Item>
    </Form>
    </>
  );
}
